import { render, staticRenderFns } from "./adminClients.vue?vue&type=template&id=32126464&"
import script from "./adminClients.vue?vue&type=script&lang=js&"
export * from "./adminClients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports